import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leo-pipeline",
  "use": "icon-leo-pipeline-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leo-pipeline\">\r\n<g transform=\"translate(-113.571 -113.571) scale(1.221818)\">\r\n<path d=\"M160 448h192v128H160V448zm256 0h192v128H416V448zm256 0h192v128H672V448z\" />\r\n  <path d=\"M320 496h128v32H320v-32zm256 0h128v32H576v-32z\" />\r\n  <path d=\"M224 320h64v128h-64V320zm512 256h64v128h-64V576z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leo-pipeline.svg
// module id = 8G20
// module chunks = 492